'use strict';

if (typeof objectFitImages == 'function') objectFitImages('img.u-object-fit');

const SiteValues = {
  ww: () => { return window.innerWidth ? window.innerWidth : window.outerWidth; },
  wh: () => { return window.innerHeight ? window.innerHeight : window.outerHeight; },
  dh: () => {
    let v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st: () => { return window.scrollY; },
  hh: () => { return document.querySelector('.l-hd').offsetHeight; },
  ua:navigator.userAgent
};

const isMobile = () => { return SiteValues.ww() <= 768 ? true : false; };
const isDesktop = () => { return SiteValues.ww() >= 769 ? true : false; };
const isTouch = () => { return (SiteValues.ua.indexOf('iPhone') >1 || SiteValues.ua.indexOf('iPad') >1 || SiteValues.ua.indexOf('Android') > 1) ? true : false; };

if (isTouch()) {
  document.body.classList.add('u-device-touch');
} else {
  document.body.classList.add('u-device-click');
};

class fadeToggle {
  constructor($target, duration = 400, delay = 40) {
    if (window.getComputedStyle($target).display === 'none') {
      this._fadeIn($target,duration,delay);
    } else {
      this._fadeOut($target,duration,delay);
    };
  };
  _fadeOut = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.opacity = 1.0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity -= coef;
      el.style.opacity = opacity;
      if (opacity <= 0) {
        el.style.display = 'none';
        clearInterval(animation);
      };
    }, delay);
  };
  _fadeIn = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.display = 'block';
    el.style.opacity = 0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity += coef;
      el.style.opacity = opacity;
      if (opacity >= 1) {
        clearInterval(animation);
      };
    }, delay);
  };
};

class slideToggle {
  constructor($target, duration = 400) {
    if (window.getComputedStyle($target).display === 'none') {
      this._slideDown($target, duration);
    } else {
      this._slideUp($target, duration);
    };
  };
  _slideUp = (el, duration) => {
    el.style.height = el.offsetHeight+'px';
    el.offsetHeight;
    el.style.transitionProperty = 'height,margin,padding';
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
  _slideDown = (el, duration) => {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty='height,margin,padding';
    el.style.height = `${height}px`;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
};

class pageScroll {
  constructor($trigger, behavior) {
    let $tiggers = document.querySelectorAll($trigger);
    if ($tiggers.length) {
      $tiggers.forEach($this => {
        $this.addEventListener('click', event => {
          event.preventDefault();
          let hash = $this.getAttribute('href');
          hash = hash.replace(/^#([\d\D]+)/, '$1');
          let $hash = document.getElementById(hash);
          if ($hash) $hash.scrollIntoView({ behavior:behavior });
        });
      });
    };
  };
};

new pageScroll('a[href^="#"]','smooth');

class header {
  constructor () {
    this.$body = document.body;
    this.$t = document.querySelector('.l-hd');
    this.$menus = document.querySelectorAll('[aria-controls=gnav]');
    this.$white = document.querySelectorAll('.is-hd-white');
    this.$gnav = document.querySelector('#gnav');
    this.$gnavLinks = document.querySelectorAll('.l-gnav-links__link');

    this.isExpanded = false;
    this.isHidden = true;

    this.$menus.forEach($menu => {
      $menu.addEventListener('click', event => {
        event.preventDefault();
        this._gnav();
      });
    });

    if (this.$gnavLinks.length) {
      this.$gnavLinks.forEach($link => {
        if ($link.classList.contains('is-trigger')) {
          $link.addEventListener('click', event => {
            event.preventDefault();
            this._gnavSubLinks($link);
          });
        };
      });
    };

    /*
    this._scroll();
    window.addEventListener('scroll', () => {
      this._scroll();
    });
    */
  };
  _gnav = () => {
    if (this.isExpanded === false) {
      this.isExpanded = true;
      this.isHidden = false;
      this.$body.classList.add('body-gnav-open');
    } else {
      this.isExpanded = false;
      this.isHidden = true;
      this.$body.classList.remove('body-gnav-open');
    };
    this.$menus.forEach($menu => {
      $menu.setAttribute('aria-expanded', this.isExpanded);
    });
    this.$gnav.setAttribute('aria-hidden', this.isHidden);
  };
  _scroll = () => {
    let st = SiteValues.st();
    if (st > 100) {
      this.$body.classList.add('body-hd-fixed');
    } else {
      this.$body.classList.remove('body-hd-fixed');
    };
  };
  _gnavSubLinks = $trigger => {
    let isExpanded = $trigger.getAttribute('aria-expanded');
    let controls = $trigger.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    if ($target) {
      let isHidden = $target.getAttribute('aria-hidden');
      if (isExpanded === 'false') {
        isExpanded = true;
        isHidden = false;
      } else {
        isExpanded = false;
        isHidden = true;
      };
      $trigger.setAttribute('aria-expanded', isExpanded);
      $target.setAttribute('aria-hidden', isHidden);
      new slideToggle($target);
    };
  };
};

const $layoutHeader = document.querySelector('.l-hd');
if ($layoutHeader) new header();

class floatingBanner {
  constructor ($t) {
    this.$t = $t;
    this.$close = this.$t.querySelector('.floating-banner-close');
    
    this.$close.addEventListener('click', event => {
      event.preventDefault();
      this._close();
    });
  };
  _close = () => {
    let isExpanded = this.$close.getAttribute('aria-expanded');
    let isHidden = this.$t.getAttribute('aria-hidden');
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    };
    this.$close.setAttribute('aria-expanded', isExpanded);
    this.$t.setAttribute('aria-hidden', isHidden);
  };
};

const $floatingBanners = document.querySelectorAll('.floating-banner');
if ($floatingBanners.length){
  $floatingBanners.forEach($banner => {
    new floatingBanner($banner);
  });
};


class inputDate {
  constructor ($t) {
    this.$t = $t;
    this._addClass();

    this.$t.addEventListener('input', () => {
      this._addClass();
    });
  };
  _addClass = () => {
    const v = this.$t.value;
    if (v) {
      this.$t.classList.add('has-value');
    } else {
      this.$t.classList.remove('has-value');
    };
  };
};

const $utilityInputDates = document.querySelectorAll('.u-input-date input[type=date]');
if ($utilityInputDates.length) {
  $utilityInputDates.forEach($input => {
    new inputDate($input);
  });
};

class filterInput {
  constructor ($t) {
    this.$t = $t;
    this.type = $t.type;
    this.name = $t.name;
    this.action = $t.dataset.filterAction;

    switch (this.type) {
    case 'date' :
      this.$t.addEventListener('change', () => {
        let v = this.$t.value;
        if (v) {
          window.location.href = `${this.action}?${this.name}=${v}`;
        };
      });
      break;
    };

  };
};

const $utilityFilterInputs = document.querySelectorAll('.u-filter-input');
if ($utilityFilterInputs.length) {
  $utilityFilterInputs.forEach($input => {
    new filterInput($input);
  });
};

class flickScroll {
  constructor ($t) {
    this.$t = $t;
    this.$clone = this.$t.cloneNode(true);
    this.$flickScroll = document.createElement('div');
    this.$flickScrollGuide = document.createElement('div');
    this.$flickScrollGuideText = document.createElement('p');
    this.$flickScroll.classList.add('flick-scroll');
    this.$flickScrollGuide.classList.add('flick-scroll-guide');
    this.$flickScrollGuideText.classList.add('flick-scroll-guide__text');
    this.$flickScrollGuideText.textContent = '横スクロール';

    this.$flickScrollGuide.appendChild(this.$flickScrollGuideText);
    this.$flickScroll.appendChild(this.$flickScrollGuide);
    this.$flickScroll.appendChild(this.$clone);
    this.$t.replaceWith(this.$flickScroll);

    this._scroll();
  };
  _scroll = () => {
    this.$flickScroll.addEventListener('scroll', event => {
      if (event.target.scrollLeft > 10) {
        this.$flickScrollGuide.classList.add('is-hidden');
      } else {
        this.$flickScrollGuide.classList.remove('is-hidden');
      };
    });
  };
};

const $articleProductScrolls = document.querySelectorAll('.article-product-content .is-scroll');
if ($articleProductScrolls.length){
  $articleProductScrolls.forEach($scroll => {
    new flickScroll($scroll);
  });
};

class SeminarApplication {
  constructor ($t) {
    this.$t = $t;
    this.startDate = $t.dataset.startDate;
    this.endDate = $t.dataset.endDate;
    
    if(this.startDate){
      this.startTimestamp = new Date(this.startDate).getTime();
      this.endTimestamp = new Date(this.endDate).getTime();
      this._updateTimer();
    };
  };
  _updateTimer = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
    const now = new Date(`${year}-${month}-${day}`).getTime();
    const startDifference =this.startTimestamp - now;
    const endDifference =this.endTimestamp - now;
    if (startDifference > 0) {
      const daysPassed = Math.floor(startDifference / (1000 * 60 * 60 * 24));
      this.$t.innerHTML = `<p class="lists-seminar-application__status is-accepting">申し込み受付中</p>`;
      this.$t.innerHTML += `<p class="lists-seminar-application__limit">受付締め切りまで　あと${daysPassed}日</p>`;
    } else if (endDifference >= 0) {
      this.$t.innerHTML = `<p class="lists-seminar-application__status">開催中</p>`;
    } else {
      this.$t.innerHTML = `<p class="lists-seminar-application__status">申し込み受付終了</p>`;
    };
  };
};

const $listsSeminarApplications = document.querySelectorAll('.lists-seminar-application');
if ($listsSeminarApplications.length){
  $listsSeminarApplications.forEach($application => {
    new SeminarApplication($application);
  });
};